import i18n from 'i18n';
import { FormLabel } from '../../form-label';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import LOCALS from 'commons/locals';
import { Cascader } from 'antd';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useCallback } from 'react';
import { DefaultOptionType } from 'types/base';
import getCascaderFilter from 'utils/getCascaderFilter';
import findCascaderOptionById from 'utils/findCascaderOptionById';
import { getBagTypeNameFromCategoryIdList } from './authentication-config';

const ProductCategory = ({
  control,
  index,
  setValue,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  setValue: UseFormSetValue<CreateRecyclingConsignmentOrderV2SchemaType>;
}) => {
  const { productCategoryCascaderOptions } = useAppSelector(selectGlobalInfo);

  const CascaderFilter = useCallback(
    (inputValue: string, path: DefaultOptionType[]) =>
      getCascaderFilter(inputValue, path),
    []
  );
  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.product_category)}:</FormLabel>
      <Controller
        name={`productList.${index}.productCategoryIdList`}
        control={control}
        render={({ field, formState: { errors } }) => {
          const isError = errors.productList?.[index]?.productCategoryIdList;

          return (
            <Cascader
              {...field}
              status={isError ? 'error' : undefined}
              options={productCategoryCascaderOptions}
              className="w-full"
              showSearch={{ filter: CascaderFilter }}
              placeholder={i18n.t(LOCALS.please_select)}
              allowClear={false}
              onChange={(value) => {
                field.onChange(value);

                const isFirstLevelChanged = field.value[0] !== value[0];
                if (isFirstLevelChanged) {
                  setValue(`productList.${index}.material`, []);
                  setValue(`productList.${index}.facebookEnabled`, 0);
                }

                // 设置包型名称（用于 BKC 验证）
                const bagTypeName = getBagTypeNameFromCategoryIdList(
                  value as number[],
                  productCategoryCascaderOptions
                );
                setValue(`productList.${index}.bagTypeName`, bagTypeName);

                const target = findCascaderOptionById(
                  value[value.length - 1],
                  productCategoryCascaderOptions
                );
                if (target) {
                  const newName = {
                    ja: target.nameJa || '',
                    en: target.nameEn || '',
                    zh_CN: target.nameZh || '',
                    zh_TW: target.nameTw || '',
                  };
                  setValue(`productList.${index}.name`, newName);
                  setValue(`productList.${index}.attrSize`, {
                    ja: target.sizeJa || '',
                    en: target.sizeEn || '',
                    zh_CN: target.sizeZh || '',
                    zh_TW: target.sizeTw || '',
                  });
                }
              }}
            />
          );
        }}
      />
    </div>
  );
};

export default ProductCategory;
